module.exports = __webpack_public_path__ + "static/media/ily-3.62cd08d7.jpg";